import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { stringify } from 'query-string';
import { GET_ONE, UPDATE, PATCH, DELETE, GET_LIST, CREATE, REMOVE_ERROR } from '../actions/constants';
import compressImage from './compressImage';
export var getKey = function getKey(action) {
  var type = action.type,
      resource = action.resource,
      payload = action.payload,
      crudActionType = action.crudActionType;
  var key = "".concat(resource, "_");

  switch (type) {
    case GET_ONE:
    case UPDATE:
    case PATCH:
    case DELETE:
      {
        var id = payload.id;
        return key + id;
      }
    // WARNING: it's not unique

    case CREATE:
      {
        return "".concat(key, "create");
      }

    case GET_LIST:
      {
        return key + stringify(payload);
      }

    case REMOVE_ERROR:
      {
        return key + crudActionType;
      }

    default:
      break;
  } // TODO: why not return `resource_${type}`;


  return null;
};
export var transFormError = function transFormError(error, action) {
  return _objectSpread(_objectSpread({}, error === null || error === void 0 ? void 0 : error.data), {}, {
    action: action,
    code: error.code,
    message: error.message,
    status: error.status,
    subCodes: error.subCodes || []
  });
};
export var anonymizeObject = function anonymizeObject() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var propertiesToChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['lastName', 'email', 'birthName', 'mobilePhoneNumber', 'phoneNumber'];
  var newValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '****';
  return JSON.parse(JSON.stringify(object), function (key, value) {
    if (typeof value === 'string' && value[0] === '{') {
      return anonymizeObject(JSON.parse(value), propertiesToChange);
    }

    if (propertiesToChange.includes(key)) {
      return newValue;
    }

    return value;
  });
};
export var transformObject = function transformObject(_ref) {
  var object = _ref.object,
      _ref$propertiesToChan = _ref.propertiesToChange,
      propertiesToChange = _ref$propertiesToChan === void 0 ? [] : _ref$propertiesToChan,
      _ref$transformer = _ref.transformer,
      transformer = _ref$transformer === void 0 ? function (value) {
    return value;
  } : _ref$transformer;

  if (!object || typeof window !== 'undefined' && (object instanceof File || object instanceof Blob)) {
    return object;
  }

  if (typeof object === 'string' || typeof object === 'number') {
    return object;
  }

  if (Array.isArray(object)) {
    return object.map(function (e) {
      return transformObject({
        object: e,
        propertiesToChange: propertiesToChange,
        transformer: transformer
      });
    });
  }

  var newObject = {};
  Object.entries(object).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (!value || typeof window !== 'undefined' && value instanceof File) {
      newObject[key] = value;
    } else if (Array.isArray(value)) {
      newObject[key] = value.map(function (e) {
        return transformObject({
          object: e,
          propertiesToChange: propertiesToChange,
          transformer: transformer
        });
      });
    } else if (_typeof(value) === 'object') {
      newObject[key] = transformObject({
        object: value,
        propertiesToChange: propertiesToChange,
        transformer: transformer
      });
    } else if (propertiesToChange.includes(key)) {
      newObject[key] = transformer(value);
    } else {
      newObject[key] = value;
    }
  });
  return newObject;
};
export var defaultPropertiesToChange = ['startDate', 'endDate', 'startDateTime', 'endDateTime', 'appointmentStartDate', 'from', 'to'];
export var transformerByTimezone = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var propertiesToChange,
        isMobile,
        moment,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          propertiesToChange = _args.length > 0 && _args[0] !== undefined ? _args[0] : defaultPropertiesToChange;
          isMobile = _args.length > 1 ? _args[1] : undefined;
          _context.next = 4;
          return import('moment-timezone');

        case 4:
          moment = _context.sent.default;
          return _context.abrupt("return", {
            in: function _in(data, store) {
              var _store$centers;

              var timeZone = store === null || store === void 0 || (_store$centers = store.centers) === null || _store$centers === void 0 || (_store$centers = _store$centers.item) === null || _store$centers === void 0 ? void 0 : _store$centers.timeZone; // Check data?.data -> it happened when data is a Response object (case: download document and no timezone in center object, just return data without transform)

              // Check data?.data -> it happened when data is a Response object (case: download document and no timezone in center object, just return data without transform)
              if (!timeZone || data !== null && data !== void 0 && data.data) return data;
              var transformedData = transformObject({
                object: data,
                propertiesToChange: propertiesToChange,
                transformer: function transformer(date) {
                  var newDate = moment(date).tz(timeZone);

                  if (isMobile) {
                    return newDate.toISOString();
                  }

                  return newDate.format('YYYY-MM-DDTHH:mm:ss');
                }
              });
              return transformedData;
            },
            out: function out(data, store) {
              var _store$centers2;

              var timeZone = store === null || store === void 0 || (_store$centers2 = store.centers) === null || _store$centers2 === void 0 || (_store$centers2 = _store$centers2.item) === null || _store$centers2 === void 0 ? void 0 : _store$centers2.timeZone;
              if (!timeZone) return data;
              var transformedData = transformObject({
                object: data,
                propertiesToChange: propertiesToChange,
                transformer: function transformer(date) {
                  return moment(date).tz(timeZone, true).toISOString();
                }
              });
              return transformedData;
            }
          });

        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function transformerByTimezone() {
    return _ref4.apply(this, arguments);
  };
}();
export var readBlob = function readBlob(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();

    reader.onload = function onLoad(e) {
      resolve(e.target.result);
    };

    reader.readAsArrayBuffer(file);
  });
};
export var toJPEGBlob = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, max) {
    var imageCompressed;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return compressImage(file, max);

        case 2:
          imageCompressed = _context2.sent;
          // eslint-disable-next-line no-console
          console.log('Original Size: ', file.size, 'Compressed size: ', imageCompressed.size, "saved ~".concat(Math.round((file.size - imageCompressed.size) * 100 * 100 / file.size) / 100, "%"));

          if (!(imageCompressed.size > file.size)) {
            _context2.next = 7;
            break;
          }

          // eslint-disable-next-line no-console
          console.log('Use original file because compress not work for this file');
          return _context2.abrupt("return", file);

        case 7:
          return _context2.abrupt("return", imageCompressed);

        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function toJPEGBlob(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();
//# sourceMappingURL=tools.js.map